import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Layout from "../components/Layout";
import { AnalysesTable } from "./Dashboard";
import { Archive as ArchiveIcon, MagnifyingGlass } from "@phosphor-icons/react";

const FILTERS = [
    { key: "all", label: "Tutte" },
    { key: "completed", label: "Completate" },
    { key: "analyzing", label: "In corso" },
    { key: "error", label: "Errore" },
];

export default function Archive() {
    const [rows, setRows] = useState(null);
    const [q, setQ] = useState("");
    const [filter, setFilter] = useState("all");

    useEffect(() => {
        api.get("/auctions").then(({ data }) => setRows(data || [])).catch(() => setRows([]));
    }, []);

    const filtered = (rows || []).filter((a) => {
        if (filter !== "all" && a.status !== filter) return false;
        if (q) {
            const s = `${a.title} ${a.comune || ""} ${a.province || ""} ${a.address || ""}`.toLowerCase();
            if (!s.includes(q.toLowerCase())) return false;
        }
        return true;
    });

    return (
        <Layout>
            <div className="mb-8 fade-up" data-testid="archive-page">
                <div className="overline mb-2">Tutte le tue analisi</div>
                <h1 className="font-display-black text-3xl sm:text-4xl text-white flex items-center gap-3">
                    <ArchiveIcon size={30} weight="duotone" className="text-[#A78BFA]" /> Archivio
                </h1>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mb-5">
                <div className="relative flex-1">
                    <MagnifyingGlass size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
                    <input
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        placeholder="Cerca per titolo, comune, provincia…"
                        data-testid="archive-search"
                        className="w-full h-11 pl-10 pr-4 rounded-lg bg-white/[0.04] border border-white/10 text-sm text-slate-100 placeholder:text-slate-500 focus:border-[#22D3EE]/50 focus:bg-white/[0.06] transition-colors outline-none"
                    />
                </div>
                <div className="flex gap-2 flex-wrap">
                    {FILTERS.map((f) => (
                        <button
                            key={f.key}
                            onClick={() => setFilter(f.key)}
                            data-testid={`archive-filter-${f.key}`}
                            className={`h-11 px-4 rounded-lg text-xs font-bold uppercase tracking-wider transition-all ${
                                filter === f.key
                                    ? "bg-gradient-to-r from-[#7C3AED] to-[#4F46E5] text-white glow-purple"
                                    : "border border-white/10 text-slate-400 hover:text-white hover:border-white/25"
                            }`}
                        >
                            {f.label}
                        </button>
                    ))}
                </div>
            </div>

            {rows === null ? (
                <div className="skeleton h-72 w-full" />
            ) : filtered.length ? (
                <AnalysesTable rows={filtered} />
            ) : (
                <div className="border border-dashed border-white/15 rounded-xl p-10 text-center text-sm text-slate-400" data-testid="archive-empty">
                    Nessuna analisi trovata.{" "}
                    <Link to="/new" className="underline hover:text-white">Avvia la prima analisi</Link>.
                </div>
            )}
        </Layout>
    );
}
